export const getYear = state => state.reportCostCenterResults.getIn(['list', 'year'])
export const getData = state => state.reportCostCenterResults.getIn(['list', 'data'])
export const getFetching = state => state.reportCostCenterResults.getIn(['list', 'fetching'])
export const getError = state => state.reportCostCenterResults.getIn(['list', 'error'])

export const getDetailsData = state => state.reportCostCenterResults.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportCostCenterResults.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportCostCenterResults.getIn(['details', 'error'])
